import u from "react";
function s(c) {
  let [e, f] = u.useState(c);
  const { current: r } = u.useRef({
    current: e
  });
  return Object.defineProperty(r, "current", {
    get: () => e,
    // eslint-disable-next-line functional/no-return-void
    set: (t) => {
      Object.is(e, t) || (e = t, f(t));
    }
  }), r;
}
export {
  s as useStatefulRef
};
//# sourceMappingURL=index.m.es.js.map
